export default __webpack_public_path__ + "media/Number6.1c9817a1f7b48613c1213c3304f83ed7.mp4";